import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CloudIcon from '@mui/icons-material/Cloud';
import CodeIcon from '@mui/icons-material/Code';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import BrushIcon from '@mui/icons-material/Brush';

const capabilities = [
  {
    title: 'Artificial Intelligence',
    description: 'Gen AI, Custom LLMs, Machine Learning & Computer Vision',
    icon: <SmartToyIcon />,
    path: '/capabilities/ai',
    bgImage: `url("data:image/svg+xml,%3Csvg width='300' height='200' viewBox='0 0 300 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='rgba(0, 0, 0, 0.12)' fill='none' transform='translate(0, 120)'%3E%3Ccircle cx='150' cy='30' r='20' stroke-width='2'/%3E%3Ccircle cx='110' cy='50' r='12' stroke-width='2'/%3E%3Ccircle cx='190' cy='50' r='12' stroke-width='2'/%3E%3Cpath d='M150,10 v-20 M110,50 l-15,15 M190,50 l15,15' stroke-width='2'/%3E%3Cpath d='M150,30 L110,50 M150,30 L190,50' stroke-width='2'/%3E%3Cpath d='M130,30 l40,0' stroke-width='1.5' stroke-dasharray='3,3'/%3E%3C/g%3E%3C/svg%3E")`
  },
  {
    title: 'AI Sales Agents',
    description: 'Intelligent automation, Lead generation & Customer engagement',
    icon: <SupportAgentIcon />,
    path: '/capabilities/ai-sales',
    bgImage: `url("data:image/svg+xml,%3Csvg width='300' height='200' viewBox='0 0 300 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='rgba(0, 0, 0, 0.12)' fill='none' transform='translate(0, 120)'%3E%3Cpath d='M120,0 l60,0 l15,30 l-90,0 Z' stroke-width='2'/%3E%3Ccircle cx='150' cy='15' r='8' stroke-width='2'/%3E%3Cpath d='M130,40 l40,0 M130,50 l20,0' stroke-width='1.5'/%3E%3Cpath d='M110,35 l80,0' stroke-width='1.5' stroke-dasharray='4,2'/%3E%3Cpath d='M140,-10 v-10 M160,-10 v-10' stroke-width='1.5'/%3E%3C/g%3E%3C/svg%3E")`
  },
  {
    title: 'Cloud Solutions',
    description: 'Infrastructure, DevOps, APIs, Automation & Scalability',
    icon: <CloudIcon />,
    path: '/capabilities/cloud-solution',
    bgImage: `url("data:image/svg+xml,%3Csvg width='300' height='200' viewBox='0 0 300 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='rgba(0, 0, 0, 0.12)' fill='none' transform='translate(0, 120)'%3E%3Cpath d='M110,0 q20,-20 40,0 q15,-30 45,0 q10,-10 25,0 q0,20 -15,30 q5,15 -10,25 q-30,5 -45,-5 q-10,10 -30,0 q-25,0 -25,-25 q-15,-10 0,-25 Z' stroke-width='2'/%3E%3Cpath d='M140,10 l0,15 M160,10 l0,15 M180,10 l0,15' stroke-width='1.5'/%3E%3C/g%3E%3C/svg%3E")`
  },
  {
    title: 'Web Development',
    description: 'React, Node.js, Ruby on Rails & Full-stack Solutions',
    icon: <CodeIcon />,
    path: '/capabilities/web-development',
    bgImage: `url("data:image/svg+xml,%3Csvg width='300' height='200' viewBox='0 0 300 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='rgba(0, 0, 0, 0.12)' fill='none' transform='translate(0, 120)'%3E%3Cpath d='M100,0 h100 v50 h-100 Z' stroke-width='2'/%3E%3Cpath d='M120,15 l-8,10 l8,10 M180,15 l8,10 l-8,10' stroke-width='2'/%3E%3Cpath d='M140,25 l20,0' stroke-width='2'/%3E%3Ccircle cx='110' cy='8' r='2' stroke-width='1.5'/%3E%3Ccircle cx='120' cy='8' r='2' stroke-width='1.5'/%3E%3Ccircle cx='130' cy='8' r='2' stroke-width='1.5'/%3E%3C/g%3E%3C/svg%3E")`
  },
  {
    title: 'Mobile Development',
    description: 'Native iOS & Android, React Native & Cross-platform',
    icon: <PhoneAndroidIcon />,
    path: '/capabilities/mobile-development',
    bgImage: `url("data:image/svg+xml,%3Csvg width='300' height='200' viewBox='0 0 300 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='rgba(0, 0, 0, 0.12)' fill='none' transform='translate(0, 120)'%3E%3Crect x='130' y='-10' width='40' height='70' rx='6' stroke-width='2'/%3E%3Cpath d='M135,0 h30 M135,10 h20 M135,20 h25' stroke-width='1.5'/%3E%3Ccircle cx='150' cy='45' r='3' stroke-width='1.5'/%3E%3Cpath d='M140,-5 h20' stroke-width='1.5'/%3E%3Cpath d='M120,15 l60,0' stroke-width='1' stroke-dasharray='3,2'/%3E%3C/g%3E%3C/svg%3E")`
  },
  {
    title: 'UX/UI Design',
    description: 'User Research, Wireframing, Prototyping & Design Systems',
    icon: <BrushIcon />,
    path: '/capabilities/ui-ux',
    bgImage: `url("data:image/svg+xml,%3Csvg width='300' height='200' viewBox='0 0 300 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='rgba(0, 0, 0, 0.12)' fill='none' transform='translate(0, 120)'%3E%3Crect x='110' y='0' width='25' height='25' rx='3' stroke-width='2'/%3E%3Crect x='145' y='0' width='45' height='25' rx='3' stroke-width='2'/%3E%3Cpath d='M115,40 h70 M115,50 h40' stroke-width='1.5'/%3E%3Ccircle cx='120' cy='12' r='4' stroke-width='1.5'/%3E%3Cpath d='M150,8 h35 M150,17 h35' stroke-width='1.5'/%3E%3C/g%3E%3C/svg%3E")`
  }
];

const borderColors = [
  '#6366F1', // Indigo
  '#EC4899', // Pink
  '#F59E42', // Orange
  '#10B981', // Green
  '#3B82F6', // Blue
  '#FBBF24', // Yellow
];

const coreTechnologies = [
  'React & React Native',
  'Node.js & TypeScript',
  'AWS Cloud Services',
  'OpenAI & LangChain',
  'TensorFlow & PyTorch',
  'Figma & Adobe Suite',
  'Python & Django',
  'Next.js & GraphQL',
  'Docker & Kubernetes',
  'MongoDB & PostgreSQL'
];

interface CapabilitiesMegaMenuProps {
  onClose: () => void;
}

const CapabilitiesMegaMenu: React.FC<CapabilitiesMegaMenuProps> = ({ onClose }) => {
  // Track fill origin (x, y) for each card (default to center)
  const [fillOrigins, setFillOrigins] = useState(Array(capabilities.length).fill({ x: '50%', y: '50%' }));

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>, index: number) => {
    const card = e.currentTarget;
    const clientX = e.clientX;
    const clientY = e.clientY;
    const i = index;
    requestAnimationFrame(() => {
      const rect = card.getBoundingClientRect();
      const x = clientX - rect.left;
      const y = clientY - rect.top;
      const percentX = `${(x / rect.width) * 100}%`;
      const percentY = `${(y / rect.height) * 100}%`;
      setFillOrigins((prev) => {
        const next = [...prev];
        next[i] = { x: percentX, y: percentY };
        return next;
      });
    });
  };

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: 'translateX(-55%)',
        width: '90vw',
        maxWidth: '1400px',
        mt: 2,
        py: 6,
        px: { xs: 2, sm: 4, md: 6 },
        bgcolor: '#ffffff',
        borderRadius: 2,
        border: '2px solid rgba(0, 0, 0, 0.15)',
        backdropFilter: 'blur(20px)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
        zIndex: 1300,
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: '2px',
          borderRadius: 'calc(8px - 2px)',
          border: '2px solid rgba(0, 0, 0, 0.06)',
          pointerEvents: 'none'
        }
      }}
    >
      <Box sx={{ width: '100%', margin: '0 auto', display: 'flex' }}>
        <Box sx={{ flex: '0 0 75%', pr: 4 }}>
          <Grid container spacing={3}>
            {capabilities.map((capability, index) => (
              <Grid item xs={12} sm={6} md={4} key={capability.title}>
                <Link
                  to={capability.path}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  onClick={onClose}
                >
                  <Box
                    onMouseEnter={e => handleMouseEnter(e, index)}
                    sx={{
                      p: 3,
                      height: '100%',
                      minHeight: '220px',
                      transition: 'all 0.3s ease',
                      borderRadius: 2,
                      backgroundColor: '#ffffff',
                      position: 'relative',
                      overflow: 'hidden',
                      backgroundImage: capability.bgImage,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        border: `2px solid ${borderColors[index]}`,
                        borderRadius: 'inherit',
                        transition: 'all 0.3s ease',
                      },
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        left: `calc(${fillOrigins[index]?.x} - 50vw)`,
                        top: `calc(${fillOrigins[index]?.y} - 50vw)`,
                        width: '100vw',
                        height: '100vw',
                        background: `${borderColors[index]}22`, // 22 = ~13% opacity
                        borderRadius: '50%',
                        zIndex: 0,
                        pointerEvents: 'none',
                        transform: 'scale(0)',
                        transition: 'transform 0.3s cubic-bezier(0.42,0,1,1)', // faster unfill animation
                      },
                      '&:hover': {
                        backgroundColor: '#ffffff',
                        transform: 'translateY(-4px)',
                        boxShadow: '0 12px 24px -8px rgba(0, 0, 0, 0.12)',
                        '&::before': {
                          borderColor: borderColors[index],
                          borderWidth: '2px'
                        },
                        '&::after': {
                          transform: 'scale(1)',
                          transition: 'transform 0.7s cubic-bezier(0,0,0.58,1)', // classic ease-out (fast end)
                        },
                        '& .title': {
                          color: '#000000',
                          transform: 'translateY(-2px)'
                        },
                        '& .description': {
                          color: 'rgba(0, 0, 0, 0.8)',
                          transform: 'translateY(-2px)'
                        }
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        position: 'relative',
                        zIndex: 1,
                      }}
                    >
                      <Typography
                        className="title"
                        variant="h6"
                        sx={{
                          fontSize: '1.25rem',
                          fontWeight: 600,
                          color: 'rgba(0, 0, 0, 0.87)',
                          transition: 'all 0.3s ease',
                          mb: 2,
                        }}
                      >
                        {capability.title}
                      </Typography>
                      <Typography
                        className="description"
                        variant="body2"
                        sx={{ 
                          fontSize: '0.9rem',
                          color: 'rgba(0, 0, 0, 0.6)',
                          lineHeight: 1.6,
                          transition: 'all 0.3s ease',
                        }}
                      >
                        {capability.description}
                      </Typography>
                    </Box>
                  </Box>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>
        
        <Box
          sx={{
            width: '2px',
            mx: 4,
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: '10%',
              bottom: '10%',
              width: '2px',
              background: 'rgba(0, 0, 0, 0.12)',
              borderRadius: '2px'
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              left: '2px',
              top: '10%',
              bottom: '10%',
              width: '2px',
              background: 'rgba(0, 0, 0, 0.06)',
              borderRadius: '2px'
            }
          }}
        />
        
        <Box sx={{ flex: '0 0 25%' }}>
          <Box
            sx={{
              position: 'relative',
              minHeight: '220px',
              p: 3,
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='300' height='400' viewBox='0 0 300 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='rgba(0, 0, 0, 0.08)' fill='none'%3E%3Cpath d='M150,50 L150,350' stroke-width='1.5' stroke-dasharray='4,4'/%3E%3Cpath d='M100,100 L200,100' stroke-width='1.5' stroke-dasharray='4,4'/%3E%3Cpath d='M100,200 L200,200' stroke-width='1.5' stroke-dasharray='4,4'/%3E%3Cpath d='M100,300 L200,300' stroke-width='1.5' stroke-dasharray='4,4'/%3E%3Cpath d='M120,75 L180,125' stroke-width='1.5'/%3E%3Cpath d='M120,175 L180,225' stroke-width='1.5'/%3E%3Cpath d='M120,275 L180,325' stroke-width='1.5'/%3E%3Cpath d='M180,75 L120,125' stroke-width='1.5'/%3E%3Cpath d='M180,175 L120,225' stroke-width='1.5'/%3E%3Cpath d='M180,275 L120,325' stroke-width='1.5'/%3E%3Ccircle cx='120' cy='75' r='3' stroke-width='2'/%3E%3Ccircle cx='180' cy='125' r='3' stroke-width='2'/%3E%3Ccircle cx='120' cy='175' r='3' stroke-width='2'/%3E%3Ccircle cx='180' cy='225' r='3' stroke-width='2'/%3E%3Ccircle cx='120' cy='275' r='3' stroke-width='2'/%3E%3Ccircle cx='180' cy='325' r='3' stroke-width='2'/%3E%3C/g%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: '-24px',
                left: 0,
                width: '48px',
                height: '3px',
                background: 'rgba(0, 0, 0, 0.15)',
                borderRadius: '2px'
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                top: '-24px',
                left: '2px',
                width: '48px',
                height: '3px',
                background: 'rgba(0, 0, 0, 0.06)',
                borderRadius: '2px'
              }
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: '1.1rem',
                fontWeight: 600,
                color: 'rgba(0, 0, 0, 0.87)',
                mb: 3,
                position: 'relative',
                zIndex: 1
              }}
            >
              Core Technologies
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, position: 'relative', zIndex: 1 }}>
              {coreTechnologies.map((tech, index) => (
                <Box
                  key={tech}
                  component="li"
                  sx={{
                    mb: 2,
                    fontSize: '0.95rem',
                    color: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    '&::before': {
                      content: '""',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      mr: 2
                    }
                  }}
                >
                  {tech}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default CapabilitiesMegaMenu; 